import * as React from 'react';
import { cva } from 'class-variance-authority';

import { cn } from '../../lib/cn';

// The state chip under a conversation name. Tone carries the meaning, so the queue
// reads by colour without parsing each label.
export const statusPillVariants = cva(
  'inline-flex items-center justify-center gap-1 rounded-[20px] bg-dusq-grey900 px-2 py-[3px] font-dusq text-[9.5px] font-bold whitespace-nowrap',
  {
    variants: {
      tone: {
        open: 'text-dusq-warning',
        waiting: 'text-dusq-warning',
        resolved: 'text-dusq-positive',
        negative: 'text-dusq-negative',
        neutral: 'text-dusq-grey400',
      },
    },
    defaultVariants: { tone: 'neutral' },
  }
);

export const StatusPill = React.forwardRef(({ className, tone, ...props }, ref) => (
  <span ref={ref} className={cn(statusPillVariants({ tone }), className)} {...props} />
));
StatusPill.displayName = 'StatusPill';
